<template>
  <div v-if="swiperReset" class="vue-asome-swiper" :style="getStyle" @mousedown.capture="swiperEv">
    <!-- 轮播可上传背景图和视频  不用组件的形式-->
    <div v-if="swiperBackground && swiperBackground.length > 0" class="swiper-style1">
      <swiper
        @click="swiperClick"
        ref="mySwiper"
        :class="[isBigScreenPreview() ? '' : 'stop-swiping', `mySwiper${myid.container_id}${myid.rect_id}`]"
        :style="getButtonStyle"
        :options="swiperOptions"
      >
        <swiper-slide
          data-mode="prev"
          :ref="`swiperSlide${item.swiperContent_id}`"
          v-for="(item, index) in swiperBackground"
          :key="index"
          :style="{ overflow: 'hidden' }"
        >
          <swiperLayoutComponentBg
            :myid="myid"
            :showBigImg="options.showBigImg"
            :pageContent="item"
            :indexVal="index"
          />
        </swiper-slide>

        <div
          ref="pagination"
          @click="setActiveSwiper"
          @mousedown="setActiveSwiper"
          v-show="showPagination"
          class="swiper-pagination"
          slot="pagination"
        ></div>
      </swiper>
      <!-- 轮播缩略图 样式7  -->
      <div class="thumbsSwiperBox" :style="getThumbsStyle" v-if="options.isThumbsSwiper">
        <swiper
          v-if="swiperBackground && swiperBackground.length > 0"
          :class="`thumbsSwiper${myid.container_id}${myid.rect_id}`"
          @click="swiperClick"
          ref="myThumbsSwiper"
          :options="thumbsSwiperOptions"
          :style="{ height: options.thumbsHeight + 'px' }"
        >
          <swiper-slide
            data-mode="prev"
            :ref="`swiperSlide${item.swiperContent_id}`"
            v-for="(item, index) in swiperBackground"
            :key="index"
            :style="getSildeStyle"
          >
            <swiperLayoutComponentBg
              :myid="myid"
              :showBigImg="options.showBigImg"
              :pageContent="item"
              :isThumbsSwiper="options.isThumbsSwiper"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div v-else class="swiper-style1">
      <!-- 空数据 -->
      <div class="null-data" v-if="emptyData">
        <img src="../../../assets/images/img-null-data-light.png" alt="" />
        <p>暂无数据</p>
      </div>
      <swiper
        v-show="!emptyData"
        @click="swiperClick"
        ref="mySwiper"
        :class="[
          isBigScreenPreview() ? '' : 'stop-swiping',
          options.effect == 'percent' ? 'percentSwiper' : '',
          options.effect == 'coverflow' && !options.isDraggable ? 'coverflowSwiper' : '',
          options.slideBorderRadius != null ? 'slideBorderRadius' : '',
          `mySwiper${myid.container_id}${myid.rect_id}`
        ]"
        :style="getButtonStyle"
        :options="swiperOptions"
        style="height: 100%"
      >
        <swiper-slide
          data-mode="prev"
          :ref="`swiperSlide${item.swiperContent_id}`"
          v-for="item in swiperContent"
          :key="item.swiperContent_id"
          :swiperContent_id="`${item.swiperContent_id}`"
          :class="`swiperSlide${item.swiperContent_id}`"
          :style="{...getColsBorder(item.swiperContent_id), ...getColsStyle(item.swiperContent_id)}"
        >
          <swiperLayoutComponentPreview
            :zoom="zoom"
            :showBigImg="options.showBigImg"
            :myid="myid"
            :pageContent="item"
            :isDraggable="options.isDraggable"
            :options="options"
            @reSetComponent="reSetComponent"
          />
        </swiper-slide>
        <div
          ref="pagination"
          @click="setActiveSwiper"
          @mousedown="setActiveSwiper"
          v-show="showPagination"
          class="swiper-pagination"
          slot="pagination"
        ></div>
      </swiper>
    </div>
    <!--    <div  v-if="!isBigScreenPreview() " class="drag_wrapper" style="left: 0"></div>-->
    <!--    <div v-if="!isBigScreenPreview()" class="drag_wrapper" style="right: 0"></div>-->
    <div v-show="!emptyData">
      <div
        v-show="options.showButton"
        @click.stop="changePagation('Next')"
        :class="['button_base_style', 'swiper-button-next', 'swiper-button-next' + _uid, options.curve ? 'button_base_curve':'']"
      >
        <cxIcon v-if="buttonIconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <img v-else-if="buttonIconType === 'img' && iconSrc" :src="iconSrc" :style="getIconStyle" />
        <span v-else :class="'icon ' + options.buttonIconClassName"></span>
      </div>
      <div
        v-show="options.showButton"
        @click.stop="changePagation('Prev')"
        :class="['button_base_style', 'swiper-button-prev', 'swiper-button-prev' + _uid, options.curve ? 'button_base_curve':'']"
      >
        <cxIcon v-if="buttonIconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <img v-else-if="buttonIconType === 'img' && iconSrc" :src="iconSrc" :style="getIconStyle" />
        <span v-else :class="'icon ' + options.buttonIconClassName"></span>
      </div>
    </div>
    <el-dialog
      :append-to-body="true"
      :visible.sync="imageDialog"
      custom-class="imageDialog"
      style="width: 100%; height: 100%"
    >
      <swiper :options="imgSwiperOptions" v-if="imageDialog" ref="myDialogSwiper" @click.prevent="imageDialog = false">
        <swiper-slide v-for="imgSrc in swiperImgList" :key="imgSrc">
          <img :src="imgSrc" alt="" :style="imgStyle" />
        </swiper-slide>
        <div
          ref="imgPagination"
          v-show="options.showBigPagination"
          class="dialog-swiper-pagination"
          slot="pagination"
        ></div>
      </swiper>
      <div class="zoom-box" v-if="options.showZoomButton">
        <span class="zoomIcon icon-portal-zoom-out" @click="zoomEditPage('zoomOut')"></span>
        <div class="input-box">
          <input type="text" v-model="zoomVal" min="10" max="1000" readonly /><span class="text">%</span>
        </div>
        <span class="zoomIcon icon-portal-zoom-in" @click="zoomEditPage('zoomIn')"></span>
      </div>
      <div>
        <div
          v-show="options.showBigButton"
          @click="changeDialogPagation('Next')"
          :class="['button_style', 'dialog-swiper-button-next', 'dialog-swiper-button-next' + _uid]"
        >
          <span class="icon-portal-arrows-right"></span>
        </div>
        <div
          v-show="options.showBigButton"
          @click="changeDialogPagation('Prev')"
          :class="['button_style', 'dialog-swiper-button-prev', 'dialog-swiper-button-prev' + _uid]"
        >
          <span class="icon-portal-arrows-left"></span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import "swiper/css/swiper.min.css"
import swiperLayoutComponentPreview from "./swiper-layoutComponent-preview.vue"
import swiperLayoutComponentEdit from "./swiper-layoutComponent-edit.vue"
import swiperLayoutComponentBg from "./swiper-layoutComponent-bg.vue"
import { _debounce, updateSubPageNameHandle } from "utils"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { UpdateData } from "utils/updateData/swiper/swiperComponentUpdateData.js"
import { Swiper as SwiperDep } from "../menus/model.js"
import { updateSubPageMapping } from "utils/updateData/publicDataUtils/subPageUpdateData.js"
const baseSwiper = new SwiperDep()
import eventMixin from "utils/event/eventMixin.js"
import plugins from "./plugin"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, plugins, dataRenderMixin],
  name: "swiper-component",
  components: {
    Swiper,
    SwiperSlide,
    swiperLayoutComponentEdit,
    swiperLayoutComponentPreview,
    swiperLayoutComponentBg
  },
  directives: {
    swiper: directive
  },
  props: {
    options: {
      type: Object,
      default: null
    },
    rect: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      componentClick: false,
      swiperContent_id2: 0,
      swiperReset: true,
      changeSpeed: false,
      speed: this.options.speed,
      autoplay: this.options.autoplay,
      paginationActiveIndex: null,
      needChangeSwiperContentId: true,
      reloadWatchers: ["pagination", "width", "height", "slidesPerView", "effect", "width", "height"],
      appId: null,
      pageId: null,
      restDataUrl: null,
      typeVal: null,
      websiteId: null,
      wfwfid: null,
      thumbsActiveIndex: 0,
      reloadTimer: null,
      requestAnimation: null,
      requestAnimation1: null,
      requestAnimation2: null,
      requestAnimation3: null,
      imageDialog: false,
      imageSwiperIndex: 0,
      zoomVal: 100,
      count: 0,
      videoTimer: null,
    }
  },

  watch: {
    "options.paginationPosition": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationLeft": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationRight": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationTop": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationBottom": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.fractionColor": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.progressbarWidth": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.progressbarHeight": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "rect.active"(n, o) {
      if (!n) {
        this.changeBulletsColor()
      }
    },
    "options.width"() {
      this.reSetComponent()
      this.initPaginationPosition()
      this.changeBulletsColor()
    },
    "options.height"() {
      this.reSetComponent()
      this.initPaginationPosition()
      this.changeBulletsColor()
    },
    "options.slidesPerView"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.effect"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.sliderMargin"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.thumbsPerView"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.thumbsMargin"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.fadeEffect": {
      deep: true,
      handler() {
        this.reSetComponent()
        this.initPaginationPosition()
      }
    },
    "options.cubeEffect": {
      deep: true,
      handler() {
        this.reSetComponent()
        this.initPaginationPosition()
      }
    },
    "options.coverflowEffect": {
      deep: true,
      handler() {
        this.reSetComponent()
        this.initPaginationPosition()
      }
    },
    "options.flipEffect": {
      deep: true,
      handler() {
        this.reSetComponent()
        this.initPaginationPosition()
      }
    },
    "options.left"() {
      this.changeBulletsColor()
    },
    "options.top"() {
      this.changeBulletsColor()
    },
    "options.loop"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.direction"() {
      this.reSetComponent()
    },
    "options.autoplay"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.speed"() {
      this.reSetComponent()
    },
    "options.paddingLeft"() {
      this.reSetComponent()
    },
    "options.paddingRight"() {
      this.reSetComponent()
    },
    "options.content": {
      deep: true,
      handler(n, o) {
        this.compare(n, o)
        // this.reSetComponent()
      }
    },
    "options.pagination.bulletsActiveColor": {
      immediate: true,
      handler(newVal, oldVal) {
        if (!this.swiperMode) {
          this.changeBulletsColor()
        }
      }
    },
    "options.pagination.bulletsPrimaryColor": {
      immediate: true,
      handler(newVal, oldVal) {
        if (!this.swiperMode) {
          this.changeBulletsColor()
        }
      }
    },
    "options.showPagination"(newVal, oldVal) {
      if (newVal) {
        this.reSetComponent()
        this.initPaginationPosition()
      }
    },
    "options.pagination": {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.reSetComponent()
        }
        this.changeBulletsColor()
        this.initPaginationPosition()
      }
    },
    "options.showButton": {
      immediate: true,
      handler(newVal, oldVal) {
        if (typeof oldVal === "undefined") {
          return
        }
        this.updateBotton(newVal)
      }
    },
    "options.swiperBackground": {
      deep: true,
      handler(n, o) {
        this.reSetComponent()
      }
    },
    "options.fractionIsThemeColor": {
      deep: true,
      handler(n, o) {
        // this.reSetComponent()
        this.initPaginationPosition()
      }
    },
    "options.changeType"() {
      this.reSetComponent()
      this.initPaginationPosition()
    },
    "options.name": {
      handler: function (newVal, oldVal) {
        if (this.options.noCacheComponent) {
          const { wfwfid } = this.$store.state.states.getDataPageIds
          let temp = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
          const index = temp.findIndex(item => item.appId === this.options.appId)
          const { detailPageId } = temp[index]
          if (detailPageId) {
            // updateSubPageNameHandle(detailPageId, newVal, wfwfid, "详情页")
            temp[index].detailPageSetting.name = newVal
          }
          updateSubPageMapping.call(this, temp)
        }
      }
    },
    "options.videoAutoPlay": {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.watchVideoEnd()
        } else {
          this.reSetComponent()
        }
      }
    },
    pageWidth() {
      this.reSetComponent()
      this.initPaginationPosition()
      this.changeBulletsColor()
    },
    isFullPage() {
      this.reSetComponent()
      this.initPaginationPosition()
      this.changeBulletsColor()
    },
    swiperMode(newVal, oldVal) {
      if (!newVal) {
        // 预览模式时清除轮播页中每个组件的选中效果
        this.clearAllActive()
        if (this.options.pagination.type === "bullets") {
          this.changeBulletsColor()
        }
      }
      if (newVal) {
        this.$store.commit("states/changeElementType", "swiperComponent")
        this.$store.commit("states/changeActiveID", {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          pageId: this.myid.pageId,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path,
        })
      }
      this.reSetComponent()
    },
    ids: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.container_id !== this.myid.container_id || newVal.rect_id !== this.myid.rect_id) {
          this.componentClick = true
        }
        if (
          newVal.container_id === this.myid.container_id &&
          newVal.rect_id === this.myid.rect_id &&
          newVal.swiperContent_id !== null &&
          typeof newVal.swiperContent_id !== "undefined"
        ) {
          // this.swiperContent_id2 = newVal.swiperContent_id
          this.$forceUpdate()
        }
        if (
          this.options.activeCol !== "" &&
          (newVal.container_id !== this.myid.container_id ||
            newVal.rect_id !== this.myid.rect_id ||
            newVal.swiperContent_id === null)
        ) {
          //如果当前选中的id与当前的col的id不一致，则清除当前col的选中态，以及col内的组件的选中态
          this.$changeOptionsEV("", "activeCol", false, null, {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            pageId: this.myid.pageId,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          }, true)
        }
      }
    },
    // swiperOptions(newVal, oldVal) {
    //   this.reSetComponent()
    // },
    dragMode(newVal, oldVal) {
      if (!newVal) {
        this.initPaginationPosition()
        this.changeBulletsColor()
        this.needChangeSwiperContentId = false
      } else {
        setImmediate(() => {
          const paginations = document.getElementsByClassName("swiper-pagination-bullet")
          if (paginations.length && !isNaN(this.paginationActiveIndex)) {
            paginations[this.paginationActiveIndex].classList.add("swiper-pagination-bullet-active")
          }
        })
      }
    },
    "options.openHideEmptyCell"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateData()
      }
    }
  },
  computed: {
    getOptions() {
      if (this.myid.elementInAutoLayoutId !== undefined) {
        return this.getAttrById(this.$store.state[this.request_prefix], this.myid, "elementInAutoLayout")
      }
      return this.getRectAttribute.call(this, this.myid).options
    },
    openZoom() {
      return this.options.openZoom
    },
    emptyData() {
      return this.options.emptyData
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("allBgColorIsThemeColor")
              ? this.options.allBgColorIsThemeColor
              : false,
            color: this.options.allBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
        case "img":
          let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
          containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
          containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
          containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
          containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
          break
        case "color":
          // containerBg.backgroundColor = bg.isThemeColor
          //   ? this.$store.state[this.request_prefix].page.themeColor
          //   : bg.color
          containerBg.backgroundColor = this.$parseColor(bg)
          break
        case "linearGradient":
          let tmp = []
          if (bg.data.stops.length > 0) {
            // bg.data.stops.forEach(item => {
            //   tmp.push(item[0] + " " + item[1] * 100 + "%")
            // })
            let dot = containerBg.backgroundImage.length > 0 ? "," : ""
            // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
            containerBg.backgroundImage += dot + this.$parseColor(bg)
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
          }
          break
        case "radialGradient":
          let radialTmp = []
          if (bg.data.stops.length > 0) {
            // bg.data.stops.forEach(item => {
            //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
            // })
            let dot = containerBg.backgroundImage.length > 0 ? "," : ""
            // containerBg.backgroundImage +=
            //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
            containerBg.backgroundImage += dot + this.$parseColor(bg)
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
          }
          break
        default:
      }
        // switch (bg.type) {
        //   case "img":
        //     let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
        //     containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
        //     containerBg.backgroundSize = bg.clipSize
        //     containerBg.backgroundPosition = bg.alignType
        //     containerBg.backgroundRepeat = bg.repeatType
        //     break
        //   case "color":
        //     containerBg.backgroundColor = bg.isThemeColor
        //       ? this.$store.state[this.request_prefix].page.themeColor
        //       : bg.color
        //     break
        //   case "linearGradient":
        //     let tmp = []
        //     if (bg.data.stops.length > 0) {
        //       bg.data.stops.forEach(item => {
        //         tmp.push(item[0] + " " + item[1] * 100 + "%")
        //       })
        //       let dot = containerBg.backgroundImage.length > 0 ? "," : ""
        //       containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
        //     }
        //     break
        //   case "radialGradient":
        //     break
        //   default:
        // }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    buttonBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.buttonBoxShadowH)) {
        this.options.buttonBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.buttonBoxShadowH[index]}px ${_this.options.buttonBoxShadowV[index]}px ${_this.options.buttonBoxShadowBlur[index]}px ${_this.options.buttonBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.buttonBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.buttonBoxShadowH}px ${this.options.buttonBoxShadowV}px ${this.options.buttonBoxShadowBlur}px ${this.options.buttonBoxShadowSpread}px ${this.$parseColor(this.options.buttonBoxShadowColor)}`
      }
      return tmpStyle
    },
    getStyle() {
      const buttonBoxStyle = {
        "--swiper-button-box-background": this.$parseColor(this.options.buttonIconBackgroundColor, {
          isThemeColor: this.options.iconBgIsThemeColor
        }),
        "--swiper-button-box-border-radius": this.options.buttonIconBackGroundBorderRadius + "px"
      }
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let bulletBg,bulletActiveBg
      if(this.options.pagination.type === "image"){
        bulletBg = `url('${this.options.pagination.paginationBg}')`
        bulletActiveBg =this.options.pagination.paginationActiveBg ? `url('${this.options.pagination.paginationActiveBg}')`:bulletBg
      }else{
        // bulletBg = this.options.bulletsPrimaryIsTheme
        //   ? this.themeColor
        //   : this.options.pagination.bulletsPrimaryColor && this.options.pagination.bulletsPrimaryColor.color
        //     ? this.options.pagination.bulletsPrimaryColor.color
        //     : this.options.pagination.bulletsPrimaryColor
        bulletBg = this.$parseColor(this.options.pagination.bulletsPrimaryColor, {
          isThemeColor: this.options.bulletsPrimaryIsTheme
        })
        // bulletActiveBg= this.options.bulletsActiveIsTheme
        //   ? this.themeColor
        //   : this.options.pagination.bulletsActiveColor && this.options.pagination.bulletsActiveColor.color
        //     ? this.options.pagination.bulletsActiveColor.color
        //     : this.options.pagination.bulletsActiveColor
        bulletActiveBg = this.$parseColor(this.options.pagination.bulletsActiveColor, {
          isThemeColor: this.options.bulletsActiveIsTheme
        })
      }
      let bulletsWidth,bulletsHeight
      if(this.options.pagination.type === "rectangle" || this.options.pagination.type === "image"){
        bulletsWidth = this.options.rectangleWidth + "px"
        bulletsHeight = this.options.rectangleHeight + "px"
      }else{
        bulletsWidth = this.options.bulletsMargin + "px"
        bulletsHeight = this.options.bulletsMargin + "px"
      }
      let buttonLeftX = this.options.buttonIconCustomTop
          ? this.options.leftButtonIconXType === "%"
              ? this.options.leftButtonIconX + "%"
              : this.options.leftButtonIconX + "px"
          : this.options.buttonIconPadding + "px"
      let buttonLeftY = this.options.buttonIconCustomTop ? this.options.leftButtonIconY + "px" : "50%"
      let buttonRightX = this.options.buttonIconCustomTop
          ? this.options.rightButtonIconXType === "%"
              ? this.options.rightButtonIconX + "%"
              : this.options.rightButtonIconX + "px"
          : this.options.buttonIconPadding + "px"
      let buttonRightY = this.options.buttonIconCustomTop ? this.options.rightButtonIconY + "px" : "50%"
      let buttonRightY1 = "auto"
      //弧形的垂直设置
      if(this.options.curve && !this.options.buttonIconCustomTop){
        buttonLeftX = "calc(50% - " + this.options.buttonIconBackgroundWidth/2 + "px)"
        buttonLeftY = this.options.buttonIconPadding + "px"
        buttonRightX = buttonLeftX
        buttonRightY = "auto"
        buttonRightY1 = buttonLeftY
      }
      let res = {
        ...this.bgStyle,
        // transform: "rotate(" + this.options.rotate + "deg)",
        "--swiper-bullets-primary-color": bulletBg,
        "--swiper-bullets-active-Color": bulletActiveBg,
        "--swiper-button-size": this.options.buttonIconSize + "px",
        // "--swiper-button-color":
        //   this.options.buttonIconColor && this.options.buttonIconColor.color
        //     ? this.options.buttonIconColor.color
        //     : this.options.buttonIconColor,
        "--swiper-button-color": this.$parseColor(this.options.buttonIconColor),
        "--swiper-button-box-padding": this.options.buttonIconPadding + "px",
        "--swiper-button-box-left-x": buttonLeftX,
        "--swiper-button-box-left-y": buttonLeftY,
        "--swiper-button-box-right-x": buttonRightX,
        "--swiper-button-box-right-y": buttonRightY,
        "--swiper-button-box-right-y1": buttonRightY1,
        // "--swiper-button-box-progressbarBackground": this.options.progressbarIsTheme
        //   ? this.themeColor
        //   : this.options.progressbarBackground && this.options.progressbarBackground.color
        //   ? this.options.progressbarBackground.color
        //   : this.options.progressbarBackground,
        "--swiper-button-box-progressbarBackground": this.$parseColor(this.options.progressbarBackground, {
          isThemeColor: this.options.progressbarIsTheme
        }),
        "--swiper-button-box-buttonIconTop": this.options.buttonIconCustomTop
          ? this.options.buttonIconTop + "px"
          : "50%",
        "--swiper-button-box-buttonIconMarginTop": this.options.buttonIconCustomTop
          ? "0px"
          : "-" + this.options.buttonIconBackgroundHeight / 2 + "px",
        "--swiper-bullets-bulletsSize": this.options.bulletsMargin + "px",
        "--swiper-bullets-bulletsWidth":bulletsWidth,
        "--swiper-bullets-bulletsHeight": bulletsHeight,
        "--swiper-bullets-activeWidth":
          this.options.pagination.type === "rectangle"
            ? this.options.rectangleActiveWidth + "px"
            : this.options.pagination.type === "image" ? bulletsWidth:this.options.bulletsMargin + "px",
        "--swiper-bullets-activeHeight":
          this.options.pagination.type === "rectangle"
            ? this.options.rectangleActiveHeight + "px"
            : this.options.pagination.type === "image" ? bulletsHeight:this.options.bulletsMargin + "px",
        "--swiper-bullets-bulletsRadius":
          this.options.pagination.type === "rectangle" ? this.options.bulletsRadius + "px" : "100%",
        "--swiper-bullets-bulletsMargin": `0 ${this.options.bulletsSize / 2}px`,
        "--swiper-button-box-width": this.options.buttonIconBackgroundWidth + "px",
        "--swiper-button-box-height": this.options.buttonIconBackgroundHeight + "px",
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color":
        //   this.options.borderColor && this.options.borderColor.color
        //     ? this.options.borderColor.color
        //     : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor),
        "border-width": borderW,
        "--swiper-padding-bottom": this.options.paddingBottom + "px",
        padding: this.getPaddingStyle,
        "--swiper-button-box-shadow": this.buttonBoxShadowStyle,
        // "--swiper-pagination-primary-color": this.options.fractionIsThemeColor
        //   ? this.themeColor
        //   : this.options.fractionColor && this.options.fractionColor.color
        //   ? this.options.fractionColor.color
        //   : this.options.fractionColor
        "swiper-pagination-primary-color": this.$parseColor(this.options.fractionColor, {
          isThemeColor: this.options.fractionIsThemeColor
        }),
      }
      if (this.options.buttonIconShowBackGround) {
        Object.assign(res, buttonBoxStyle)
      }
      return res
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  0px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    getButtonStyle() {
      let width = (100 - this.options.middlePage) / 2 - (this.options.sliderMargin / 100) * 10 //没找到为什么要*10 目前因为这样宽度刚好
      return {
        ...this.getSwiperHeight,
        "--swiper-button-top": this.options.buttonTop + "px",
        "--swiper-button-left": this.options.buttonLeft + "px",
        "--middle-page-percent": this.options.middlePage ? this.options.middlePage + "%" : 0,
        "--swiper-page-width": width + "%",
        "--cube-shadow-blur": this.options.shadowBlur + "px",
        "--slide-width": this.options.slideWidth ? this.options.slideWidth + "px" : "100%",
        "--slide-height": this.options.slideHeight ? this.options.slideHeight + "px" : "100%",
        "--slide-border-radius": this.options.slideBorderRadius ? this.options.slideBorderRadius + "px" : 0
      }
    },
    dragMode() {
      return this.$store.state.states.dragMode
    },
    showPagination() {
      return this.options.showPagination
    },
    buttonStyle() {
      return this.options.swiperButtonType
    },
    ids() {
      return this.$store.state.states.activeID
    },
    elementType() {
      return this.$store.state.states.elementType
    },
    swiperMode() {
      return typeof this.options.swiperMode === "undefined" ? true : this.options.swiperMode
    },
    swiperContent() {
      // 编辑页最多显示20条数据，解决数据很多造成的卡顿问题，预览页正常显示
      return !this.isBigScreenPreview() && this.options.content?.length > 20 ? this.options.content.slice(0,20) : this.options.content
      // return this.options.content
    },
    videoAutoPlay() {
      return this.options.videoAutoPlay
    },
    swiperOptions() {
      var _self = this
      // this.fixSwiperSlideSize()
      const res = {
        // 分页器配置
        pagination: {
          el: ".swiper-pagination",
          clickable: this.options.pagination.clickable, //点击切换
          type: this.options.pagination.type === "rectangle" ||  this.options.pagination.type === "image"? "bullets" : this.options.pagination.type
          // 自定义分页指示器，未完
          // type:"custom",
          // renderCustom:function (swiper,current,total){
          //   let html = ""
          //   for(let i=0;i<total;i++){
          //     html += `<span>test</span>`
          //   }
          //   return html
          // }
        },
        watchSlidesProgress: false,
        //速度
        // speed: this.firstCreateComponent ? this.options.speed : 230,
        speed: Number(this.options.speed),
        effect: this.options.effect,
        //单页显示的页数
        slidesPerView: this.options.slidesPerView,
        slidesPerGroup: this.options.changeType === "all" ? this.options.slidesPerView : 1,
        // 当前页位置
        centeredSlides: this.options.centeredSlides,
        //淡入淡出效果配置项
        fadeEffect: this.options.fadeEffect || baseSwiper.fadeEffect,
        //方块效果配置项
        cubeEffect: this.options.cubeEffect || baseSwiper.cubeEffect,
        //3d流效果配置项
        coverflowEffect: this.options.coverflowEffect || baseSwiper.coverflowEffect,
        //3d翻转效果配置项
        flipEffect: this.options.flipEffect || baseSwiper.flipEffect,
        // 设定初始化时slide的索引
        initialSlide: this.swiperContent_id2,
        //Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)
        direction: this.options.direction,
        // 自动切换图配置
        autoplay: this.videoAutoPlay ? false : this.options.autoplay,
        freeMode: this.options.freeMode,
        // 箭头配置
        navigation: {
          nextEl: this.options.navigation.nextEl + this._uid,
          prevEl: this.options.navigation.prevEl + this._uid
        },
        // // 环状轮播
        loop: this.options.loop,
        //强制加载所有图片后再初始化
        preloadImages: true,
        // slidesPerView: "auto",
        // loopedSlides: 3,
        // loopAdditionalSlides: 0,
        // // 一个屏幕展示的数量
        // slidesPerView: 1,
        // 间距
        spaceBetween: this.options.sliderMargin != undefined ? this.options.sliderMargin : 26,
        // 修改swiper自己或子元素时，自动初始化swiper
        observer: false,
        observeSlideChildren: false,
        // 修改swiper的父元素时，自动初始化swiper
        observeParents: true,
        noSwiping: true,
        noSwipingClass: "stop-swiping",
        // thumbs: {
        //   swiper: {
        //     el: '.thumbsSwiper',
        //   }
        // },
        on: {
          slideChangeTransitionStart() {
            setTimeout(() => {
              if (!this.$wrapperEl) return
              const copyEl = this.$wrapperEl[0].querySelector(".swiper-slide-duplicate.swiper-slide-active")
              if (copyEl) {
                const chartEl = copyEl.getElementsByClassName("chart-box")
                for (let i = 0; i < chartEl.length; i++) {
                  const item = chartEl[i]
                  const ids = {}
                  Array.from(item.parentNode.classList)
                    .find(it => it.includes("container_id_"))
                    .split("-")
                    .forEach(
                      str => (ids[str.slice(0, str.lastIndexOf("_"))] = Number(str.slice(str.lastIndexOf("_") + 1)))
                    )
                  const chartOptions = _self.swiperContent
                    .find(it => it.swiperContent_id === ids.swiperContent_id)
                    .elementOptions.find(it => it.elementInSwiperId === ids.elementInSwiperId).chartOption
                  const instance = _self.$echarts.init(item)
                  instance.setOption(chartOptions)
                }
              }
            }, 300)
            if (_self.openZoom && _self.options.effect === "fade") {
              // 取消放大动画
              let swiper = ".mySwiper" + _self.myid.container_id + _self.myid.rect_id
              $(swiper).find(".swiper-slide-prev .componentBox").addClass("animation1")
              $(swiper).find(".swiper-slide .componentBox").removeClass("animation0")
            }
          },
          slideChangeTransitionEnd() {
            let swiper = ".mySwiper" + _self.myid.container_id + _self.myid.rect_id
            if (!_self.isBigScreenPreview()) {
              _self.swiperContent_id2 = this.realIndex
              _self.$nextTick(() => {
                if (_self.options.isThumbsSwiper) _self.thumbsMove()
                // 添加放大动画
                if (_self.openZoom && _self.options.effect === "fade") {
                  $(swiper).find(".swiper-slide-active .componentBox").addClass("animation0")
                  $(swiper).find(".swiper-slide .componentBox").removeClass("animation1")
                }
              })
            }
            _self.watchVideoEnd()
          },
          click(e) {
            // 点击图片组件放大功能 循环轮播被复制的轮播页组件点击事件会失效
            if (e.target?.classList?.contains("img-box") && _self.options.zoomImage) {
              let ids = null
              if (e.target?.offsetParent?.dataset?.elementids) {
                ids = JSON.parse(e.target?.offsetParent?.dataset?.elementids)
              } else {
                ids = JSON.parse(e.target?.offsetParent?.offsetParent?.dataset?.elementids)
              }
              if (!ids.hasOwnProperty("elementInSwiperId")) return
              if (_self.isBigScreenPreview()) {
                _self.imageDialog = true
                _self.imageSwiperIndex = _self.swiperContent.findIndex(
                  item => item.swiperContent_id === ids.swiperContent_id
                )
              }
            }
          }
        }
      }
      this.isBigScreenPreview() && this.reSetComponent()
      // console.log(res)
      return res
    },
    // 缩略图轮播
    thumbsSwiperOptions() {
      var _self = this
      // this.fixSwiperSlideSize()
      const res = {
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        //速度
        // speed: this.firstCreateComponent ? this.options.speed : 230,
        speed: this.options.speed,
        // effect: this.options.effect,
        //单页显示的页数
        slidesPerView: this.options.thumbsPerView,
        // 当前页位置
        // centeredSlides: this.options.centeredSlides,
        //淡入淡出效果配置项
        // fadeEffect: this.options.fadeEffect || baseSwiper.fadeEffect,
        // 设定初始化时slide的索引
        // initialSlide: this.swiperContent_id2,
        //Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)
        direction: this.options.direction,
        // 自动切换图配置
        autoplay: this.options.autoplay,
        freeMode: this.options.freeMode,
        // 箭头配置
        // navigation: {
        //   nextEl: this.options.navigation.nextEl + this._uid,
        //   prevEl: this.options.navigation.prevEl + this._uid
        // },
        // // 环状轮播
        loop: this.options.loop,
        //强制加载所有图片后再初始化
        preloadImages: true,
        // loopedSlides: 3,
        // loopAdditionalSlides: 0,
        // 间距
        spaceBetween: this.options.thumbsMargin,
        // 修改swiper自己或子元素时，自动初始化swiper
        observer: false,
        observeSlideChildren: false,
        // 修改swiper的父元素时，自动初始化swiper
        observeParents: true,
        // noSwiping: true,
        // noSwipingClass: "stop-swiping",

        on: {
          slideChangeTransitionEnd() {
            if (!_self.isBigScreenPreview()) {
              // _self.swiperContent_id2 = this.realIndex
            }
          },
          click() {
            let index = this.clickedIndex
            if (_self.options.loop) {
              index = Number(this.clickedIndex - _self.options.thumbsPerView) + 1
              let swiper = ".mySwiper" + _self.myid.container_id + _self.myid.rect_id + " .swiper-slide"
              let len = $(swiper).length
              if (index > len || index == len) {
                index = index - len
              }
            }
            _self.$refs.mySwiper.$swiper.slideTo(index)
          }
        }
      }
      this.isBigScreenPreview() && this.reSetComponent()
      console.log(res)
      return res
    },
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.$swiper : undefined
    },
    subSwiper() {
      return this.$refs.myThumbsSwiper ? this.$refs.myThumbsSwiper.$swiper : undefined
    },
    swiperBackground() {
      return this.options.swiperBackground
    },
    thumbsSwiper() {
      return this.options.thumbsSwiper
    },
    getSwiperHeight() {
      let swiperHeight = "100%"
      if (this.options.swiperHeight) {
        swiperHeight = this.options.swiperHeight + "%"
      }
      return {
        height: swiperHeight
      }
    },
    buttonIconType() {
      return this.options.buttonIconType ? this.options.buttonIconType : "icon"
    },
    iconSrc() {
      return this.options.iconSrc ? this.options.iconSrc : ""
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    getIconStyle() {
      return {
        // "--color": this.options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.buttonIconColor && this.options.buttonIconColor.color
        //   ? this.options.buttonIconColor.color
        //   : this.options.buttonIconColor,
        "--color": this.$parseColor(this.options.buttonIconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        fontSize: this.options.buttonIconSize + "px",
        width: this.options.buttonIconSize + "px",
        height: this.options.buttonIconSize + "px"
      }
    },
    getThumbsPaddingStyle() {
      let padding = `${this.options.thumbsPadding}px`
      if (this.options.thumbsPaddingTypeFlag === 2) {
        padding = ` ${this.options.thumbsPaddingTop}px  ${this.options.thumbsPaddingRight}px  ${this.options.thumbsPaddingBottom}px ${this.options.thumbsPaddingLeft}px`
      }
      return padding
    },
    bgThumbsStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.thumbsBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("thumbsBgIsTheme") ? this.options.thumbsBgIsTheme : false,
            color: ""
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            break
          default:
        }
      })
      return containerBg
    },
    thumbsBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.thumbsBoxShadowH)) {
        this.options.thumbsBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.thumbsBoxShadowH[index]}px ${_this.options.thumbsBoxShadowV[index]}px ${_this.options.thumbsBoxShadowBlur[index]}px ${_this.options.thumbsBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.thumbsBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.thumbsBoxShadowH}px ${this.options.thumbsBoxShadowV}px ${this.options.thumbsBoxShadowBlur}px ${this.options.thumbsBoxShadowSpread}px ${this.$parseColor(this.options.thumbsBoxShadowColor)}`
      }
      return tmpStyle
    },
    getThumbsStyle() {
      return {
        ...this.bgThumbsStyle,
        padding: this.getThumbsPaddingStyle,
        "--thumbs-padding-left": this.options.padding
          ? this.options.padding + "px"
          : this.options.paddingLeft
          ? this.options.paddingLeft + "px"
          : 0,
        "--thumbs-padding-right": this.options.padding
          ? this.options.padding + "px"
          : this.options.paddingRight
          ? this.options.paddingRight + "px"
          : 0
      }
    },
    getSildeStyle() {
      let borderW = ""
      if (Array.isArray(this.options.thumbsBorderWidth)) {
        this.options.thumbsBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.thumbsBorderWidth}px`
      }
      let activeBorderW = ""
      if (Array.isArray(this.options.thumbsActiveBorderWidth)) {
        this.options.thumbsActiveBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
      } else {
        activeBorderW += ` ${this.options.thumbsActiveBorderWidth}px`
      }
      return {
        overflow: "hidden",
        opacity: this.options.thumbsOpacity / 100,
        "box-shadow": this.thumbsBoxShadowStyle,
        "border-top-left-radius": this.options.thumbsBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.thumbsBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.thumbsBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.thumbsBorderBottomLeftRadius + "px",
        "border-style": this.options.thumbsBorderStyle,
        // "border-color": this.options.thumbsBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.thumbsBorderColor && this.options.thumbsBorderColor.color
        //   ? this.options.thumbsBorderColor.color
        //   : this.options.thumbsBorderColor,
        "border-color": this.$parseColor(this.options.thumbsBorderColor, {
          isThemeColor: this.options.thumbsBorderIsThemeColor
        }),
        "border-width": borderW,

        "--active-opacity": this.options.thumbsActiveOpacity / 100 || 1,
        "--active-box-shadow": this.thumbsActiveBoxShadowStyle,
        "--active-border-top-left-radius": this.options.thumbsActiveBorderTopLeftRadius
          ? this.options.thumbsActiveBorderTopLeftRadius + "px"
          : 0,
        "--active-border-top-right-radius": this.options.thumbsActiveBorderTopRightRadius
          ? this.options.thumbsActiveBorderTopRightRadius + "px"
          : 0,
        "--active-border-bottom-right-radius": this.options.thumbsActiveBorderBottomRightRadius
          ? this.options.thumbsActiveBorderBottomRightRadius + "px"
          : 0,
        "--active-border-bottom-left-radius": this.options.thumbsActiveBorderBottomLeftRadius
          ? this.options.thumbsActiveBorderBottomLeftRadius + "px"
          : 0,
        "--active-border-style": this.options.thumbsActiveBorderStyle,
        // "--active-border-color": this.options.thumbsActiveBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.thumbsActiveBorderColor && this.options.thumbsActiveBorderColor.color
        //   ? this.options.thumbsActiveBorderColor.color
        //   : this.options.thumbsActiveBorderColor,
        "--active-border-color": this.$parseColor(this.options.thumbsActiveBorderColor, {
          isThemeColor: this.options.thumbsActiveBorderIsThemeColor
        }),
        "--active-border-width": activeBorderW
      }
    },
    thumbsActiveBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.thumbsActiveBoxShadowH)) {
        this.options.thumbsActiveBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.thumbsActiveBoxShadowH[index]}px ${_this.options.thumbsActiveBoxShadowV[index]}px ${_this.options.thumbsActiveBoxShadowBlur[index]}px ${_this.options.thumbsActiveBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.thumbsActiveBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.thumbsActiveBoxShadowH}px ${this.options.thumbsActiveBoxShadowV}px ${this.options.thumbsActiveBoxShadowBlur}px ${this.options.thumbsActiveBoxShadowSpread}px ${this.$parseColor(this.options.thumbsActiveBoxShadowColor)}`
      }
      return tmpStyle
    },
    pageWidth() {
      return this.$store.state[this.request_prefix].page.pageWidth
    },
    isFullPage() {
      return this.$store.state[this.request_prefix].page.isFullPage
    },
    imgSwiperOptions() {
      return {
        // 分页器配置
        pagination: {
          el: ".dialog-swiper-pagination",
          clickable: "true", //点击切换
          type: "bullets"
        },
        loop: true,
        // 箭头配置
        navigation: {
          nextEl: "dialog-swiper-button-next" + this._uid,
          prevEl: "dialog-swiper-button-prev" + this._uid
        },
        initialSlide: this.imageSwiperIndex
      }
    },
    swiperImgList() {
      let list = []
      this.options.content.forEach(item => {
        item.elementOptions.forEach(element => {
          if (element.innerElement === "imageComponent" && element.imgSrc) {
            list.push(element.imgSrc)
          }
        })
      })
      return list
    },
    imageStyle(imgSrc) {
      return {
        "background-image": "url(" + imgSrc + ")",
        "background-repeat": "no-repeat",
        "background-size": "contain",
        "background-position": "center center"
      }
    },
    imgStyle() {
      return {
        scale: this.zoomVal + "%"
      }
    },
    hasGetDetailDataPlugin() {
      return this.options.pluginName?.includes("getDetailDataPlugin")
    }
  },
  methods: {
    getColsBorder(swiperContent_id) {
      if (
        (this.options.activeCol === undefined && this.ids.swiperContent_id === undefined) ||
        this.options.activeCol === ""
      )
        return {}
      if (this.options.activeCol === swiperContent_id) {
        return {
          "box-shadow": "inset 0 0 0 1px var(--themeColor)"
        }
      }
    },
    getColsStyle(swiperContent_id) {
      if(this.options.curve){
        if(!$(`.mySwiper${this.myid.container_id}${this.myid.rect_id} .swiper-slide`).hasClass("swiper-slide-animate-curve")){
          $(`.mySwiper${this.myid.container_id}${this.myid.rect_id} .swiper-slide`).addClass("swiper-slide-animate-curve")
        }
        let slidesPerView = this.options.slidesPerView,
            slidesAllNumber = this.options.content.length,
            direction = this.options.direction,
            activeIndex = 0,
            pi = Math.PI
        if(this.$refs.mySwiper){
          activeIndex = this.$refs.mySwiper.$swiper?.realIndex
        }
        if(slidesPerView >= 3){
          let radianVal1 = (this.options.swiperRadian / (30 + 10) * pi).toFixed(2)
          let radianVal1_1 = radianVal1 > 0 ? radianVal1 : -radianVal1
          if(activeIndex === swiperContent_id){
            if(direction === "vertical"){
              return {
                transform: `scale(1, 1) translateX(${radianVal1}vw)`,
                width: `calc(100% - ${radianVal1_1}vw)`
              }
            }else{
              return {
                transform: `scale(1, 1) translateY(${radianVal1}vh)`,
                height: `calc(100% - ${radianVal1_1}vh)`
              }
            }
          }
          //  需要修改前后几位的数
          let nextNumber = Math.floor(slidesPerView / 2)
          if(nextNumber >= 1){
            for(let i=1;i< Number(nextNumber + 1);i++){
              let nextI = activeIndex + i, prevI = activeIndex - i
              if(nextI > (slidesAllNumber - 1)){
                nextI = nextI - slidesAllNumber
              }
              if(prevI < 0){
                prevI = slidesAllNumber + prevI
              }
              let radianVal2 = (((2 * radianVal1) / slidesPerView) * (nextNumber - i)).toFixed(2)
              if(i === nextNumber){
                radianVal2 = 0
              }
              let radianVal2_1 = radianVal2 > 0 ? radianVal2 : -radianVal2
              if(nextI === swiperContent_id || prevI === swiperContent_id){
                if(direction === "vertical"){
                  return {
                    transform: `scale(1, 1) translateX(${radianVal2}vw)`,
                    width: `calc(100% - ${radianVal2_1}vw)`
                  }
                }else{
                  return {
                    transform: `scale(1, 1) translateY(${radianVal2}vh)`,
                    height: `calc(100% - ${radianVal2_1}vh)`
                  }
                }
              }
            }
          }
        }
      }else{
        return {}
      }
    },
    thumbsMove() {
      let swiper = ".thumbsSwiper" + this.myid.container_id + this.myid.rect_id + " .swiper-slide" //缩略图轮播
      let mySwiper = this.$refs.mySwiper.$swiper
      let subSwiper = this.$refs.myThumbsSwiper.$swiper
      $(swiper).removeClass("active-thumbs")
      if (!this.options.loop) {
        $(swiper).removeClass("swiper-slide-active")
      }
      if (!this.options.loop) {
        let activeThumbs = $(swiper).eq(mySwiper.activeIndex) //当前显示项
        this.thumbsActiveIndex = mySwiper.activeIndex
        activeThumbs.addClass("swiper-slide-active")
        if (!activeThumbs.hasClass("swiper-slide-visible")) {
          //是否在可视区域
          // 当前显示在active的后面
          if (activeThumbs.index() > subSwiper.activeIndex) {
            let thumbsPer = this.options.thumbsPerView - 1
            subSwiper.slideTo(activeThumbs.index() - thumbsPer)
          } else {
            subSwiper.slideTo(activeThumbs.index())
          }
        }
      } else {
        this.thumbsActiveIndex = Number(mySwiper.activeIndex + this.options.thumbsPerView - 1)
        let activeThumbs = $(swiper).eq(this.thumbsActiveIndex).addClass("active-thumbs") //当前显示项
        if (!activeThumbs.hasClass("swiper-slide-visible")) {
          //是否在可视区域
          // 当前显示在active的后面
          if (activeThumbs.index() > subSwiper.activeIndex) {
            let thumbsPer = this.options.thumbsPerView - 1
            subSwiper.slideTo(activeThumbs.index() - thumbsPer)
          } else {
            subSwiper.slideTo(activeThumbs.index())
          }
        }
      }
    },
    compare(n, o, path = "") {
      for (let k in n) {
        if (n[k] !== o[k] || typeof n[k] !== typeof o[k]) {
          console.log(path + "-" + k)
          this.reSetComponent()
        } else if (n[k] === o[k] && typeof n[k] === typeof o[k] && typeof n[k] === "object") {
          this.compare(n[k], o[k], path + "-" + k)
        }
      }
    },
    getPageContentEdit() {
      return this.swiperContent[typeof this.swiperContent_id2 === "undefined" ? 0 : this.swiperContent_id2]
    },
    changeElementTypeByBullet() {
      this.$store.commit("states/changeActiveID", { ...this.ids, elementInSwiperId: null, swiperContent_id: null })
      this.$store.commit("states/changeElementType", "swiperComponent")
    },
    bulletClick(e) {
      this.$store.commit("states/changeActiveID", { ...this.ids, elementInSwiperId: null, swiperContent_id: null })
      this.$store.commit("states/changeElementType", "swiperComponent")
    },
    setActiveSwiper() {
      const changeActiveID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        pageId: this.myid.pageId,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path,
      }
      if (Object.keys(this.ids).some(k => this.ids[k] !== changeActiveID[k]) && this.elementType != "swiperComponent") {
        this.$store.commit("states/changeActiveID", changeActiveID)
        this.$store.commit("states/changeElementType", "swiperComponent")
      }
      const clearActive = {
        ...this.ids
      }
      clearActive.elementInSwiperId = null
      this.clearAllActive()
      if (this.getPageContentEdit() && this.getPageContentEdit().elementOptions.find(it => it.isActive)) {
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
    },
    changePagation(type) {
      // !this.isBigScreenPreview() &&
      // this.$store.commit("states/changeActiveID", { ...this.ids, elementInSwiperId: null, swiperContent_id: null })
      // this.$store.commit("states/changeElementType", "swiperComponent")
      this.setActiveSwiper()
      //有视频，单独处理，后期再优化多个视频情况
      if (this.swiperBackground?.length) {
        if (this.swiperBackground[0].type == "video") {
          return
        }
      }
      console.log(this.swiperBackground)
      try {
        this.swiper["slide" + type]()
        this.initGoDetailPageHandle()
      } catch (error) {}
    },
    changeDialogPagation(type) {
      try {
        let swiperEv = this.$refs.myDialogSwiper ? this.$refs.myDialogSwiper.$swiper : undefined
        swiperEv["slide" + type]()
      } catch (error) {
        console.log(error)
      }
    },
    updateFillFlexTypeEv(direction) {
      this.$nextTick(() => {
        if (direction === "horizontal") {
          // 左右
          this.$refs.swiper_edit_box.style.flexDirection = "row"
        } else {
          // 上下
          this.$refs.swiper_edit_box.style.flexDirection = "column"
        }
      })
    },
    updateBotton(newVal) {
      this.requestAnimation = requestAnimationFrame(() => {
        if (
          !(
            this.$el &&
            this.$el.getElementsByClassName &&
            this.$el.getElementsByClassName("swiper-button-next")[0] &&
            this.$el.getElementsByClassName("swiper-button-next")[0].style &&
            this.$el.getElementsByClassName("swiper-button-next")[0].style.display
          )
        ) {
          this.updateBotton(newVal)
        } else {
          if (newVal) {
            this.$el.getElementsByClassName("swiper-button-next")[0].style.display = "block"
            this.$el.getElementsByClassName("swiper-button-prev")[0].style.display = "block"
          } else {
            this.$el.getElementsByClassName("swiper-button-next")[0].style.display = "none"
            this.$el.getElementsByClassName("swiper-button-prev")[0].style.display = "none"
          }
        }
      })
    },
    async initLoopUpdateSwiper() {
      await this.updateData()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => {
          this.updateData()
        }, this.options.updateTimer * 1000)
      }
    },
    initFetchIds() {
      const { appId, pageId, restDataUrl, typeVal, websiteId, wfwfid } = this.options.myFetchParam
        ? this.options.myFetchParam
        : {}
      const { pageId: _pageId, wfwfid: _wfwfid, websiteId: _websiteId } = this.$store.state.states.getDataPageIds
      this.appId = appId ? appId : this.options.appId
      this.pageId = this.myid.pageId || _pageId
      this.restDataUrl = restDataUrl
      this.typeVal = typeVal
      this.websiteId = _websiteId
      this.wfwfid = _wfwfid
      if (pageId !== this.pageId || wfwfid !== this.wfwfid || websiteId !== this.websiteId) {
        this.$changeOptionsEV(
          {
            typeVal: typeVal,
            restDataUrl: restDataUrl,
            pageId: this.pageId,
            wfwfid: this.wfwfid,
            websiteId: this.websiteId,
            appId
          },
          "myFetchParam",
          false,
          null,
          {
            rect_id: this.myid.rect_id,
            container_id: this.myid.container_id,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          },
          true
        )
      }
    },
    async updateData() {
      this.initFetchIds()
      const upDateData = new UpdateData(this)
      const { pageId, wfwfid, websiteId, appId } = this
      const { engineInstanceId, cacheDataTypes, restDataUrl, engineInstance, dataCenterContent } =
        ((!this.hasGetDetailDataPlugin && !this.options.multiImageDetail) && await getAppointCacheData.call(this, pageId, wfwfid, websiteId, appId)) || {}
      if ((!engineInstanceId || !cacheDataTypes || !restDataUrl) && !this.hasGetDetailDataPlugin && !this.options.multiImageDetail) return
      const ids = {
        rect_id: this.myid.rect_id,
        container_id: this.myid.container_id,
        pageId: this.myid.pageId,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      if(engineInstanceId) {
        this.$changeOptionsEV(engineInstanceId, "engineInstanceId", false, null, ids, true)
        //为了数据推送需要的属性
        this.$changeOptionsEV(engineInstance.id, "engineInstanceId_10", false, null, ids, true)
      }
      if (!this.options.myFetchParam) {
        this.$changeOptionsEV({}, "myFetchParam", false, null, ids, true)
      }
      this.$changeOptionsEV(cacheDataTypes?.length ? cacheDataTypes[0].publicId : "", "typeVal", true, "myFetchParam", ids, true)
      const updateCb = (val, content_name, deep, deepName, ids) => {
        this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
      }
      let drawLayoutAlready, completeData
      ;[drawLayoutAlready, completeData] = await upDateData.upDateRect(
        this.getOptions,
        cacheDataTypes,
        restDataUrl,
        this.myid,
        updateCb,
        dataCenterContent
      )
      const createCb = param => {
        this.$store.dispatch(this.request_prefix + "/addComponentInSwiper", param)
      }
      const delSlideCb = param => {
        this.$store.dispatch(this.request_prefix + "/swiperContentControl", param)
      }
      upDateData.updateSwiperContent({ completeData, drawLayoutAlready, createCb, updateCb, delSlideCb })
    },
    fixSwiperSlideSize() {
      this.requestAnimation1 = requestAnimationFrame(() => {
        if (!(this.dragMode || this.swiperMode)) {
          if (this.$refs.mySwiper) {
            this.swiperContent.forEach(content => {
              const swiperSlideEl = this.$refs[`swiperSlide${content.swiperContent_id}`][0].$el
              swiperSlideEl.style.width = this.options.width + "px"
            })
          } else {
            this.fixSwiperSlideSize()
          }
        }
      })
    },
    changeBulletsColor: _debounce(function () {
      requestAnimationFrame(() => {
        let classList = this.$el.getElementsByClassName("swiper-pagination-bullet")
        if (classList.length === 0) {
          //dom还没出来 递归一下
          this.changeBulletsColor()
        } else {
          const primaryColor = this.options.bulletsPrimaryIsTheme
            ? this.themeColor
            : this.options.pagination.bulletsPrimaryColor && this.options.pagination.bulletsPrimaryColor.color
            ? this.options.pagination.bulletsPrimaryColor.color
            : this.options.pagination.bulletsPrimaryColor
          const activeColor = this.options.bulletsActiveIsTheme
            ? this.themeColor
            : this.options.pagination.bulletsActiveColor && this.options.pagination.bulletsActiveColor.color
            ? this.options.pagination.bulletsActiveColor.color
            : this.options.pagination.bulletsActiveColor
          // dom有了 开始处理逻辑
          Array.from(classList).forEach((span, index) => {
            if (span.className.includes("swiper-pagination-bullet-active")) {
              this.paginationActiveIndex = index
              // span.style["background-color"] = activeColor
            } else {
              // span.style["background-color"] = primaryColor
            }
          })
        }
      })
    }, 100),
    //不要防抖，否则一个页面上有多个swiper只能渲染一次分页
    initPaginationPosition () {
      if (this.swiperMode || !this.showPagination) return
      requestAnimationFrame(() => {
        // pagination
        const position = this.options.paginationPosition
        const type = this.options.pagination.type
        const el = this.$refs.pagination
        if (!el) this.initPaginationPosition()
        if (!el) return
        if (el && !el.classList) this.initPaginationPosition()
        el?.classList.remove("swiper-pagination-bullets")
        el?.classList.remove("swiper-pagination-fraction")
        switch (position) {
          case "left":
            initStyle.call(this, el)
            if (this.options.direction === "horizontal" || type !== "progressbar") {
              el.style.transform = "rotate(90deg)"
            }
            if (type !== "progressbar") {
              el.style.top = "50%"
            }
            el.style.right = ""
            el.style.left = this.options.paginationLeft + "px"
            break
          case "right":
            initStyle.call(this, el)
            if (this.options.direction === "horizontal" || type !== "progressbar") {
              el.style.transform = "rotate(90deg)"
            }
            if (type !== "progressbar") {
              el.style.top = "50%"
            }
            el.style.left = "auto"
            el.style.right = this.options.paginationRight + "px"
            break
          case "top":
            initStyle.call(this, el)
            if (type !== "progressbar") {
              el.style.width = "100%"
            }
            el.style.top = this.options.paginationTop + "px"
            break
          case "bottom":
            initStyle.call(this, el)
            if (type !== "progressbar") {
              el.style.width = "100%"
            }
            el.style.top = "auto"
            el.style.bottom = this.options.paginationBottom + "px"
            break
          case "leftTop":
            initStyle.call(this, el)
            el.style.top = this.options.paginationTop + "px"
            el.style.left = this.options.paginationLeft + "px"
            el.style.right = ""
            el.style.bottom = ""
            break
          case "rightTop":
            initStyle.call(this, el)
            el.style.top = this.options.paginationTop + "px"
            el.style.right = this.options.paginationRight + "px"
            el.style.left = "auto"
            el.style.bottom = "auto"
            break
          case "leftBottom":
            initStyle.call(this, el)
            el.style.top = "auto"
            el.style.right = "auto"
            el.style.left = this.options.paginationLeft + "px"
            el.style.bottom = this.options.paginationBottom + "px"
            break
          case "rightBottom":
            initStyle.call(this, el)
            el.style.top = "auto"
            el.style.right = this.options.paginationRight + "px"
            el.style.left = "auto"
            el.style.bottom = this.options.paginationBottom + "px"
            break
          default:
            break
        }
        function initStyle(el) {
          if (!el) return
          if (el.style) el.removeAttribute("style")
          if (type === "fraction") {
            const {
              fractionFontFamily,
              fractionFontSize,
              fractionFontWeight,
              fractionLineHeight,
              fractionLineHeightType,
              fractionFontStyle,
              fractionTextDecoration,
              fractionLetterSpacing,
              fractionWritingMode,
              fractionTextAlign,
              fractionVerticalAlign
            } = this.options.pagination
            const style = el.style
            // style.color = this.options.fractionIsThemeColor
            //   ? this.themeColor
            //   : this.options.fractionColor && this.options.fractionColor.color
            //   ? this.options.fractionColor.color
            //   : "white"
            style.color = this.$parseColor(this.options.fractionColor || "white", {
              isThemeColor: this.options.fractionIsThemeColor
            })
            style.fontFamily = fractionFontFamily
            style.fontSize = fractionFontSize + "px"
            style.fontWeight = fractionFontWeight
            style.fontStyle = fractionFontStyle
            style.textDecoration = fractionTextDecoration
            style.height = fractionLineHeightType === '%' ? (fractionLineHeight / 100 * fractionFontSize + "px") : (fractionLineHeight + "px")
            style.letterSpacing = fractionLetterSpacing + "px"
            if (fractionWritingMode === "vertical-lr") {
              style.display = "flex"
              style.flexDirection = "column"
              switch (fractionTextAlign) {
                case "left":
                case "justify":
                  style.justifyContent = "start"
                  break
                case "center":
                  style.justifyContent = "center"
                  break
                case "right":
                  style.justifyContent = "end"
              }
            } else {
              style.display = "flex"
              style.justifyContent = "center"
              switch (fractionVerticalAlign) {
                case "top":
                  style.alignItems = "start"
                  break
                case "center":
                  style.alignItems = "center"
                  break
                case "bottom":
                  style.alignItems = "end"
              }
              switch (fractionTextAlign) {
                case "left":
                case "justify":
                  style.justifyContent = "start"
                  break
                case "center":
                  style.justifyContent = "center"
                  break
                case "right":
                  style.justifyContent = "end"
              }
            }
          }
          if (type === "progressbar") {
            if (this.options.direction === "horizontal") {
              el.style.width = this.options.progressbarWidth + "%"
              el.style.height = this.options.progressbarHeight + "px"
            } else {
              el.style.width = this.options.progressbarHeight + "px"
              el.style.height = this.options.progressbarWidth + "%"
            }
            // el.style.background = this.options.bulletsPrimaryIsTheme
            //   ? this.themeColor
            //   : this.options.pagination.bulletsPrimaryColor && this.options.pagination.bulletsPrimaryColor.color
            //   ? this.options.pagination.bulletsPrimaryColor.color
            //   : this.options.pagination.bulletsPrimaryColor
            el.style.background = this.$parseColor(this.options.pagination.bulletsPrimaryColor, {
              isThemeColor: this.options.bulletsPrimaryIsTheme
            })
          }
        }
      })
    },
    reSetComponent() {
      this.swiperReset = false
      this.$nextTick(() => {
        this.swiperReset = true
      })
    },
    clearAllActive() {
      this.swiperContent.forEach(content => {
        if (content.elementOptions.find(it => it.isActive)) {
          const clearActive = {
            ...this.myid,
            swiperContent_id: content.swiperContent_id,
            elementInSwiperId: null
          }
          this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
        }
      })
    },
    handleActiveSwiperContentId(activeIndex) {
      if (this.swiperMode) return
      const swiperContent = this.getOptions?.content
      const realIndex =
        activeIndex > swiperContent.length ? 0 : activeIndex === 0 ? swiperContent.length - 1 : activeIndex - 1
      const swiperContent_id = swiperContent[realIndex].swiperContent_id
      const param = { ...this.myid, swiperContent_id }
      this.$store.commit("states/changeActiveID", param)
    },

    updateStates() {
      const param = { ...this.myid, swiperContent_id: this.swiperContent_id2 }
      this.setActiveEv(param)
      if (Object.keys(param).some(k => param[k] !== this.ids[k])) {
        this.$store.commit("states/changeActiveID", param)
      }
      if (this.$store.state.states.elementType !== this.options.innerElement) {
        this.$store.commit("states/changeElementType", "swiperComponent")
      }
    },
    swiperEv(e) {
      if (e.target?.classList?.contains("swiper-pagination-bullet")) return
      if (!this.options.isDraggable && !this.isBigScreenPreview()) {
        if (this.options.content && this.options.content.length > 0) {
          this.mockClickElementInSwiper(e)
        }
        return
      }
      this.changeBulletsColor()
      if (this.isBigScreenPreview()) return
      this.mockClickElementInSwiper(e)
    },
    mockClickElementInSwiper(e) {
      const ev = e.target || e
      const className = ev.className
      // console.log("className",className)
      if (typeof className === "string" && className.includes("vdr")) {
        if (ev.dataset.elementids) {
          const ids = JSON.parse(ev.dataset.elementids)
          // if (this.ids.container_id === ids.container_id && this.ids.rect_id === ids.rect_id) {
          const shape = ev.dataset.shape
          $(".swiper-slide").removeClass("outline")
          if (this.options.isDraggable) {
            this.$store.commit("states/changeActiveID", ids)
            this.$store.commit("states/changeElementType", shape)
          } else {
            const className = `.container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}`
            $(`${className} .swiper-slide.swiperSlide${ids.swiperContent_id}`).addClass("outline")
          }
          this.clearAllActive()
          this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", ids)
          // 取消轮播组件选中态
          if (this.request_prefix !== "bigScreen") {
            this.$store.dispatch(this.request_prefix + "/unsetActive", this.myid)
          }
          // }
          //  else {
          //   delete ids.elementInSwiperId
          //   this.$store.commit("states/changeActiveID", ids)
          //   this.$store.commit("states/changeElementType", "swiperComponent")
          //   if (!this.$getOptions(ids).isActive) this.$store.dispatch(this.request_prefix + "/setActive", ids)
          // }
        } else {
          this.clickSwiperEmpty(ev)
        }
      } else if (typeof className === "string" && className.includes("swiper-slide")) {
        //轮播样式外壳点击
        this.swiperContent_id2 = Number(ev.getAttribute("swiperContent_id"))
        this.mockClickElementInSwiper(ev.parentNode)
      } else {
        this.mockClickElementInSwiper(ev.parentNode)
      }
    },
    clickSwiperEmpty(e) {
      const clearActive = {
        ...this.ids
      }
      clearActive.elementInSwiperId = null
      const changeActiveID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        pageId: this.myid.pageId,
        swiperContent_id: this.swiperContent_id2,
        elementInSwiperId: null,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path,
      }
      if (Object.keys(changeActiveID).some(k => changeActiveID[k] !== this.ids[k])) {
        this.$store.commit("states/changeElementType", "swiperComponent")
        this.$store.commit("states/changeActiveID", changeActiveID)
      }
      this.clearAllActive()
      if (this.getPageContentEdit() && this.getPageContentEdit().elementOptions.find(it => it.isActive)) {
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
    },
    swiperClick() {
      this.changeBulletsColor()
      if (this.isBigScreenPreview()) return
      this.updateStates()
    },
    setActiveEv(param) {
      const rectAttr = this.getRectAttribute(param)
      if (!rectAttr.active) {
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: param.container_id,
          rect_id: param.rect_id
        })
      }
    },
    initGoDetailPageHandle() {
      const _this = this
      if (!this.isBigScreenPreview()) {
        return
      }
      //  todo 未完
      /**
       * 初始化化点击手势
       */
      // const pageId = `pageId_${this.pageId}-`
      // for (let i = 0; i < _this.options.content.length; i++) {
      //   // console.log("in")
      //   console.log(
      //     `.container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`,
      //     document.querySelector(
      //       `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`
      //     )
      //   )
      //   const currentDomId = document
      //     .querySelector(
      //       `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`
      //     )
      //     .getAttribute("id")
      //   if (
      //     `swiperBox${_this.myid.container_id}${_this.myid.rect_id}${_this.options.content[i].swiperContent_id}` ===
      //     currentDomId
      //   ) {
      //     if (
      //       _this.options.content[i].options.detailsPageTarget?.length ===
      //       _this.options.content[i].elementOptions.length
      //     ) {
      //       document.querySelector(
      //         `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`
      //       ).onmouseover = function () {
      //         this.classList.add("hoverStyle")
      //       }
      //
      //       document.querySelector(
      //         `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`
      //       ).onmouseout = function () {
      //         this.classList.remove("hoverStyle")
      //       }
      //     } else {
      //       for (let j = 0; j < _this.options.content[i].options.detailsPageTarget?.length; j++) {
      //         document.querySelector(
      //           `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id}-swiperContent_id_${_this.options.content[i].swiperContent_id}-elementInSwiperId_${_this.options.content[i].options.detailsPageTarget[j]}`
      //         ).onmouseover = function () {
      //           this.classList.add("hoverStyle")
      //         }
      //         document.querySelector(
      //           `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id}-swiperContent_id_${_this.options.content[i].swiperContent_id}-elementInSwiperId_${_this.options.content[i].options.detailsPageTarget[j]}`
      //         ).onmouseout = function () {
      //           this.classList.remove("hoverStyle")
      //         }
      //       }
      //     }
      //   }
      // }
      // /**
      //  * 只有预览页才需要注册点击跳转详情页事件
      //  */
      // document.querySelector(
      //   `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .rect`
      // ).onclick = function (event) {
      //   for (let k = 0; k < _this.options.content.length; k++) {
      //     const currentDomId = document
      //       .querySelector(
      //         `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`
      //       )
      //       .getAttribute("id")
      //     if (
      //       `swiperBox${_this.myid.container_id}${_this.myid.rect_id}${_this.options.content[k].swiperContent_id}` ===
      //       currentDomId
      //     ) {
      //       if (_this.options.content[k].elementOptions.length) {
      //         document.querySelector(
      //           `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`
      //         ).style.cursor = "pointer"
      //         // 如果当前选中的col中的所有组件都可以跳转详情页，那么认为整个col都可以跳转详情页
      //         window.open(_this.options.content[k].options.dataUrl)
      //       }
      //       // if (
      //       //   _this.options.content[k].options.detailsPageTarget?.length ===
      //       //   _this.options.content[k].elementOptions.length
      //       // ) {
      //       //   document.querySelector(
      //       //     `.${pageId}container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id} .swiper-slide-active .componentBox`
      //       //   ).style.cursor = "pointer"
      //       //   // 如果当前选中的col中的所有组件都可以跳转详情页，那么认为整个col都可以跳转详情页
      //       //   window.open(_this.options.content[k].options.dataUrl)
      //       // } else {
      //       //   // for (let j = 0; j < _this.options.content[k].options.detailsPageTarget?.length; j++) {
      //       //   // for (let j = 0; j < _this.options.content[k].options.dataUrl?.length; j++) {
      //       //   for (let n = 0; n < _this.options.content[k].elementOptions?.length; n++) {
      //       //     // const className = `container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id}-swiperContent_id_${_this.options.content[k].swiperContent_id}-elementInSwiperId_${_this.options.content[k].options.detailsPageTarget[j]}`
      //       //     // const className = `container_id_${_this.myid.container_id}-rect_id_${_this.myid.rect_id}-swiperContent_id_${_this.options.content[k].swiperContent_id}-elementInSwiperId_${_this.options.content[k].elementOptions[n].elementInSwiperId}`
      //       //     // if (event.target.offsetParent.className.includes(className)) {
      //       //     event.target.offsetParent.style.cursor = "pointer"
      //       //     window.open(_this.options.content[k].options.dataUrl)
      //       //     // }
      //       //   }
      //       // }
      //     }
      //   }
      // }
    },
    zoomEditPage(type) {
      let STEP = 10
      if (type === "zoomIn") {
        this.zoomVal = this.zoomVal + STEP > 1000 ? 1000 : Number(this.zoomVal + STEP)
      } else if (type === "zoomOut") {
        this.zoomVal = this.zoomVal - STEP < 10 ? 10 : Number(this.zoomVal - STEP)
      }
    },
    cancleLodingStatu(){
      let isAddNewRect = sessionStorage.getItem("isAddNewRect")
      if(!isAddNewRect){
        return
      }
      // let isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
      // const parentClass = isWaterFall ?  "grid-item-content" :"layout-cell-container"
      const parentClass = "layout-cell-container"
      let parentNode = this.getParentNodeByClassName(this.$el, [], parentClass)
      if(parentNode.length === 0){
        return
      }
      // parentNode[0]?.removeAttribute("isLoading")
      let classList = parentNode[0]?.getElementsByClassName("loading-newRect")[0]?.classList
      if(classList){
        let loadingRect = document.getElementsByClassName("loading-newRect")
        loadingRect.length === 1 && sessionStorage.removeItem("isAddNewRect")
        classList.remove("loading-newRect")
      }
    },
    getParentNodeByClassName(e, res = [], parentClass) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        // if(elClasslist.length === 0 ){
        //   return res
        // }
        if ([].find.call(elClasslist, it => it === parentClass)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNodeByClassName(parentNode, res, parentClass)
        }
      } else {
        return res
      }
    },
    // initGoDetailPageHandle() {
    //   /**
    //    * 只有预览页才需要注册点击跳转详情页事件
    //    */
    //
    //   document.getElementsByClassName("swiper-slide-active")[0].onclick = event => {
    //     debugger
    //     for (let i = 0; i < this.rect.options.content.length; i++) {
    //       const currentDomId = document.querySelector(".swiper-slide-active .componentBox").getAttribute("id")
    //       if (
    //         `swiperBox${this.myid.container_id}${this.myid.rect_id}${this.rect.options.content[i].swiperContent_id}` ===
    //         currentDomId
    //       ) {
    //         if (
    //           this.rect.options.content[i].options.detailsPageTarget?.length ===
    //           this.rect.options.content[i].elementOptions.length
    //         ) {
    //           // 如果当前选中的col中的所有组件都可以跳转详情页，那么认为整个col都可以跳转详情页
    //           window.open(this.rect.options.content[i].options.dataUrl)
    //         } else {
    //           for (let j = 0; i < this.rect.options.content[i].options.detailsPageTarget?.length; j++) {
    //             const className = `container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}-swiperContent_id_${this.rect.options.content[i].swiperContent_id}-elementInSwiperId_${this.rect.options.content[i].options.detailsPageTarget[j]}`
    //             if (event.target.offsetParent.className.includes(className)) {
    //               window.open(this.rect.options.content[i].options.dataUrl)
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    watchVideoEnd() {
      // if (!this.videoAutoPlay && this.swiperBackground?.length > 0) return // 不需要该判断 需要划过轮播时关闭其他正在播放的视频，回来时继续播放
      const swiper = this.$refs.mySwiper.$swiper
      const index = swiper?.activeIndex
      const direction = this.autoplay.reverseDirection
      const loop = this.options.loop
      let video = "video[autoPlay]"
      if (this.videoAutoPlay) {
        video = "video"
      }
      const that = this
      clearTimeout(this.videoTimer)
      this.videoTimer = null
      this.$nextTick(()=> {
        this.pauseOtherVideo() // 关闭其他正在播放的视频
        const currentSlide = $(".mySwiper" + this.myid.container_id + this.myid.rect_id)
        .find(".swiper-slide")
        .eq(index)
        const curVideo = currentSlide.find(video).get(0)
        if (curVideo) {
          const button = currentSlide.find(".vjs-big-play-button")
          if (button.length) {
            button.addClass("opacity0")
          }
          curVideo.play()
          // 开启声音
          this.autoPlayListener(index)
          if (this.videoAutoPlay) {
            curVideo.addEventListener('ended', function () {
              console.log('播放结束 :>>',curVideo);
              if (!loop && swiper.slides?.length === 1) {
                // 没开启循环 切轮播页只有一页时 继续播放
                that.watchVideoEnd()
                return
              }
              if (direction) {// 往左播放
                if (!loop && index === 0) {// 没开启循环 但是播放到第一页时需要往后
                  swiper.slideNext()
                } else {
                  swiper.slidePrev()
                }
              } else {// 往右播放
                if (!loop && index === swiper.slides?.length - 1) {// 没开启循环 但是播放到最后一页时需要往前
                  swiper.slidePrev()
                } else {
                  swiper.slideNext()
                }
              }
            })
          }
        } else if (this.videoAutoPlay) {
          // const videoImage = currentSlide.find(".video-component-wrap .video-img-box")
          const video = currentSlide[0]?.getElementsByTagName("video")
          if (!video || !video.length) {// 视频显示成图片
            // 按设置的停留时间继续播放就行
            this.videoTimer = setTimeout(() => {
              if (!loop && swiper.slides?.length === 1) {
                // 没开启循环 切轮播页只有一页时 继续播放
                that.watchVideoEnd()
                return
              }
              if (direction) {
                if (!loop && index === 0) {// 没开启循环 但是播放到第一页时需要往后
                  swiper.slideNext()
                } else {
                  swiper.slidePrev()
                }
              } else {
                if (!loop && index === swiper.slides?.length - 1) {// 没开启循环 但是播放到最后一页时需要往前
                  swiper.slidePrev()
                } else {
                  swiper.slideNext()
                }
              }
            }, this.autoplay.delay);
          }
        }
      })
    },
    pauseOtherVideo() {
      let videos = $(".mySwiper" + this.myid.container_id + this.myid.rect_id).find(".video-component-wrap")
      for (let i = 0; i < videos.length; i++) {
        const video = videos[i].getElementsByTagName("video")[0]
        video && video.pause()
      }
    },
    // 自动触发点击事件播放视频
    autoPlayListener(index) {
      var container = $(".mySwiper" + this.myid.container_id + this.myid.rect_id)
        .find(".swiper-slide")
        .eq(index)
        .find(".video-container")
      const event = new MouseEvent("click", {
        bubbles: true,
        cancelable: true
      })
      const videoControl = container?.find(".vjs-mute-control")[0]
      if (videoControl) videoControl.dispatchEvent(event)
    },
  },
  mounted() {
    if (this.options.noCacheComponent || this.hasGetDetailDataPlugin || this.options.multiImageDetail) {
      this.initLoopUpdateSwiper()
    }
    this.initPaginationPosition()
    this.$initPlugin(this.options?.pluginName)
    this.$nextTick(()=>{
      this.cancleLodingStatu()
      setTimeout(() => {
        this.watchVideoEnd()
      }, 1000);
      // 存储最大轮播数
      if (!this.options.hasOwnProperty("swiperContent") && this.swiperContent && this.swiperContent?.length) {
        this.$changeOptionsEV(this.swiperContent?.length, "swiperContent", false, null, this.myid, true)
      }
    })

    // 添加监听事件，为了接收外部组件传递的参数
    this.$eventBus.$on(`update-swiper-data-eventBus-${this.myid.container_id}-${this.myid.rect_id}`, async msg => {
      // console.log("msg", msg)
      if (msg) {
        await this.updateData()
      }
    })
  },
  beforeDestroy() {
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
    cancelAnimationFrame(this.requestAnimation)
    cancelAnimationFrame(this.requestAnimation1)
    clearTimeout(this.videoTimer)
  }
}
</script>
<style>
  .swiper-slide-animate-curve{
    transition: all .5s ease-in-out;
    -webkit-transition: all .5s ease-in-out;
    -o-transition: all .5s ease-in-out;
    -moz-transition: all .5s ease-in-out;
    -ms-transition: all .5s ease-in-out;
  }
</style>
<style scoped lang="scss">
::v-deep.mySwiper {
  --swiper-navigation-size: 40px;
}
::v-deep.swiper-container {
  padding-bottom: var(--swiper-padding-bottom);
  overflow: unset;
}
::v-deep .swiper-pagination-progressbar-fill {
  background: var(--swiper-button-box-progressbarBackground) !important;
}

::v-deep .swiper-pagination-bullet {
  margin: var(--swiper-bullets-bulletsMargin) !important;
  width: var(--swiper-bullets-bulletsWidth);
  height: var(--swiper-bullets-bulletsHeight);
  border-radius: var(--swiper-bullets-bulletsRadius);
  background: var(--swiper-bullets-primary-color);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  opacity: 1;
  display: inline-block !important;
}

::v-deep .swiper-container-vertical > .swiper-pagination-bullets {
  transform: rotate(90deg);
  left: 0;
  right: auto;
}

.pagination-bottom {
  top: 99%;
}
.button_base_style {
  z-index: 999;
  width: var(--swiper-button-box-width);
  height: var(--swiper-button-box-height);
  border-radius: var(--swiper-button-box-border-radius);
  background: var(--swiper-button-box-background);
  box-shadow: var(--swiper-button-box-shadow);
}
.button_base_style .icon {
  font-size: var(--swiper-button-size);
  color: var(--swiper-button-color);
}
.button_base_style .icon:before {
  color: var(--swiper-button-color);
}
.swiper-button-next {
  right: var(--swiper-button-box-right-x);
  top: var(--swiper-button-box-right-y);
}
.swiper-button-prev {
  left: var(--swiper-button-box-left-x);
  top: var(--swiper-button-box-left-y);
}
.button_base_curve.swiper-button-next,
.button_base_curve.swiper-button-prev{
  margin-top: 0;
}
.button_base_curve.swiper-button-next{
  bottom: var(--swiper-button-box-right-y1);
}
.button_base_style::before {
  color: var(--swiper-button-color);
  font-size: var(--swiper-button-size);
}
.button_base_style::after {
  display: none;
}
.swiper-button-next {
  transform: rotate(180deg);
}

.vue-asome-swiper {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.styles {
  width: 100%;
  height: 100%;
}
.swiper_edit_box {
  width: 100%;
  height: 100%;
  display: flex;
}
.swiper_deep {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
}

.swiper_top {
  width: 100%;
  position: absolute;
  z-index: 101;
}

.swiper_img {
  width: 100%;
  height: 100%;
  background-size: cover;
}
.drag_wrapper {
  position: absolute;
  /*width: 8%;*/
  height: 100%;
  /*z-index: 99;*/
  top: 0;

  right: 0;
  width: 100%;
  background-color: blue;
  z-index: 99999;
}
.drag_wrapper:hover {
  cursor: move;
}
.swiper-style1 {
  width: 100%;
  height: 100%;
}
::v-deep .swiper-pagination-bullet-active {
  background: var(--swiper-bullets-active-Color) !important;
  width: var(--swiper-bullets-activeWidth);
  height: var(--swiper-bullets-activeHeight);
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}
.thumbsSwiperBox {
  /* width: 100%; */
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: var(--thumbs-padding-left);
  right: var(--thumbs-padding-right);
  overflow: hidden; // 处理轮播样式7 分页器溢出的问题，只需要处理编辑页即可，预览页swiper-container   hidden
}
.thumbsSwiperBox .swiper-slide.swiper-slide-active {
  border-style: var(--active-border-style) !important;
  border-color: var(--active-border-color) !important;
  border-width: var(--active-border-width) !important;
  opacity: var(--active-opacity) !important;
  box-shadow: var(--active-box-shadow) !important;
  border-top-left-radius: var(--active-border-top-left-radius) !important;
  border-top-right-radius: var(--active-border-top-right-radius) !important;
  border-bottom-right-radius: var(--active-border-bottom-right-radius) !important;
  border-bottom-left-radius: var(--active-border-bottom-left-radius) !important;
}
.thumbsSwiperBox .swiper-slide.active-thumbs {
  border-style: var(--active-border-style) !important;
  border-color: var(--active-border-color) !important;
  border-width: var(--active-border-width) !important;
  opacity: var(--active-opacity) !important;
  box-shadow: var(--active-box-shadow) !important;
  border-top-left-radius: var(--active-border-top-left-radius) !important;
  border-top-right-radius: var(--active-border-top-right-radius) !important;
  border-bottom-right-radius: var(--active-border-bottom-right-radius) !important;
  border-bottom-left-radius: var(--active-border-bottom-left-radius) !important;
}
.percentSwiper .swiper-slide.swiper-slide-prev,
.percentSwiper .swiper-slide.swiper-slide-next {
  width: var(--swiper-page-width) !important;
}
.percentSwiper .swiper-slide.swiper-slide-active {
  width: var(--middle-page-percent) !important;
}
::v-deep .swiper-container-cube .swiper-cube-shadow {
  filter: blur(var(--cube-shadow-blur));
}
.coverflowSwiper .swiper-slide {
  width: var(--slide-width) !important;
  height: var(--slide-height) !important;
}
.slideBorderRadius .swiper-slide {
  border-radius: var(--slide-border-radius);
  overflow: hidden;
}
.swiper-container-horizontal > .swiper-pagination-progressbar {
  top: auto;
  bottom: 0px;
}
.swiper-pagination {
  color: var(--swiper-pagination-primary-color);
}
.swiper-slide.outline {
  outline: 2px solid var(--themeColor);
}

.swiper-slide {
  transform: scale(1, 1);
}
.animation0 {
  -webkit-animation: animation0 7s linear 0s;
  animation: animation0 7s linear 0s;
  opacity: 1;
}

.animation1 {
  -webkit-animation: animation1 1000ms cubic-bezier(0.5, 0, 0.2, 1) 0s;
  animation: animation1 1000ms cubic-bezier(0.5, 0, 0.2, 1) 0s;
}
/* 放大图片弹窗 */
::v-deep .imageDialog {
  &.el-dialog {
    box-shadow: unset;
    background: unset;
    border: unset;
    width: 100%;
    height: 100%;
    margin-top: 0 !important;
    margin-bottom: 0;
  }
  .el-dialog__body {
    border-top: unset;
    border-bottom: unset;
    background: unset;
    height: 100%;
    padding: 0;
  }
  .el-dialog__header {
    display: none;
  }
  .swiper-container {
    height: 100%;
    padding-bottom: 100px;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 800px;
      object-fit: contain;
    }
  }
  .button_style {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-content: center;
    justify-content: center;
    z-index: 1;
    cursor: pointer;
    span {
      line-height: 48px;
      font-size: 28px;
      color: #ffffff;
    }
    &.dialog-swiper-button-prev {
      left: 16px;
    }
    &.dialog-swiper-button-next {
      right: 16px;
    }
  }
  .dialog-swiper-pagination {
    position: absolute;
    text-align: center;
    z-index: 1;
    top: auto;
    bottom: 10px;
  }
  .swiper-pagination-bullet {
    margin: 5px !important;
    width: 10px;
    height: 10px;
    background: #ffffff;
    border-radius: 50%;
  }
  .swiper-pagination-bullet-active {
    background: #2b67ff !important;
  }
}
::v-deep .zoom-box {
  position: absolute;
  z-index: 2;
  bottom: 160px;
  left: 50%;
  transform: translateX(-50%);
  width: 904px;
  height: 34px;
  line-height: 34px;
  background: rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    background-color: transparent;
    color: #ffffff;
    border-radius: 8px;
    text-align: left;
    padding: 8px 5px;
    font-size: 13px;
    width: 44px;
    height: 34px;
    line-height: 34px;
    vertical-align: top;
    border: none;
    &:focus {
      box-shadow: none;
    }
  }
  .input-box {
    position: relative;
    .text {
      position: absolute;
      right: 2px;
      font-size: 13px;
      line-height: 34px;
      color: #ffffff;
    }
  }
  .zoomIcon {
    z-index: 10;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
    width: 22px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    &.icon-portal-zoom-out {
      left: 4px;
    }
    &.icon-portal-zoom-in {
      right: 4px;
    }
  }
}
// 分页有时会不显示
::v-deep .swiper-pagination.swiper-pagination-bullets, .swiper-pagination.swiper-pagination-fraction {
  // bottom: unset;
}
@-webkit-keyframes animation0 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }

  100% {
    -webkit-transform: scale(1.05, 1.05);
    transform: scale(1.05, 1.05);
  }
}

@keyframes animation0 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }

  100% {
    -webkit-transform: scale(1.05, 1.05);
    transform: scale(1.05, 1.05);
  }
}

@-webkit-keyframes animation1 {
  0% {
    -webkit-transform: scale(1.05, 1.05);
    transform: scale(1.05, 1.05);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1.5, 1.5);
    transform: scale(1.5, 1.5);
    opacity: 0;
  }
}

@keyframes animation1 {
  0% {
    -webkit-transform: scale(1.05, 1.05);
    transform: scale(1.05, 1.05);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1.5, 1.5);
    transform: scale(1.5, 1.5);
    opacity: 0;
  }
}
</style>
